export default {
    state: {
        informacion_contactos: [],
        loading: false,
    },
    getters: {
        informacion_contactos: (state) => state.informacion_contactos,
        loading: state => state.loading,
    },
    mutations: {
        SET_INFORMACION_CONTACTOS: (state, payload) => state.informacion_contactos = payload,
        setLoading: (state, payload) => state.loading = payload,
    },
    actions: {
        fetch({commit}, payload) {
          this.dispatch('index', payload)
            .then((response) => {
              commit('SET_INFORMACION_CONTACTOS', response.datos)
            })
        },
        listaDeudores({commit, dispatch}, payload) {
            return new Promise((res, rej) => {
                this.getters.api.get('/exportar/deudores', {
                    responseType: 'blob',
                })
                .then((response) => {
                    res(response)
                }).catch((error) => {
                    rej(error)
                });
            });
        },
        informacionDemografica({commit, dispatch}, payload) {
            return new Promise((res, rej) => {
                this.getters.api.post('/sociodemografica/importar', payload)
                .then(response => {
                    res(response)
                }).catch(error =>
                    rej(error)
                )
            })
        }
    }
}